import { Component, OnInit, TemplateRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ToasterService } from '../services/toaster.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { serviceURLService } from '../service/serviceURL';
import { SharingDataService } from '../service/sharing-data.service';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { proposalData } from '../doctors-professional-indemnity-quote/doctors-proposal-data.model';

@Component({
  selector: 'app-doctor-professional-proposal',
  templateUrl: './doctor-professional-proposal.component.html',
  styleUrls: ['./doctor-professional-proposal.component.css'],
  providers: [ToasterService]
})
export class DoctorProfessionalProposalComponent implements OnInit {
  modalRef: BsModalRef;
  f: proposalData = new proposalData();
  activeTab:string = 'details';
  proposalFormDPI: boolean;
  selectedFile: File;
  selectedFileName: string;
  fileArray = [];
  fileNameArray = [];
  uploading: boolean;
  public startDate;
  policyStartDate: Date;
  policyEndDate: Date;
  quoteIdUnitedIndia: string;
  loading: boolean;
  data:{};
  error: string;
  shouldBe18 : any;
  DOBrequired: any;
  value: Date;
  hold: string;
  claims: string;
  attached: string;
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(private _location: Location, private toasterService: ToasterService, private router: Router, private activatedRoute: ActivatedRoute, private serviceURLService: serviceURLService, private sharingDataService: SharingDataService,private modalService: BsModalService) {
    this.startDate = new Date();
    this.policyStartDate = this.startDate
    this.f.retroactiveDate = this.startDate
   }
  
  ngOnInit() {
    this.getAutopopulatedData();
    this.setPolicyEndDate();
    setTimeout(() => {
      var memberChoice = (<HTMLInputElement>document.querySelector('input[name="attached"]:checked')).value;
    // console.log("memberchouce ",memberChoice);
    }, 1000);
    
  }

  getAutopopulatedData(){
    setTimeout(() => {
      this.f.firstName = localStorage.getItem("name").split(" ")[0];
      this.f.lastName = localStorage.getItem("name").split(" ").slice(-2).join(' ');
      this.f.mobile = localStorage.getItem("mobileNumber");
      this.f.email = localStorage.getItem("email");
      this.f.selectedSpecialization = localStorage.getItem("specialisation");
      this.f.sumInsured = localStorage.getItem("sumInsured");
    }, 500);    
  }

  showProposal(){
    this.proposalFormDPI = true;
  }

  // for tab change functionality
  details(activeTab){
    this.activeTab = activeTab;
  }

  questions(activeTab){
    this.activeTab = activeTab;
  }

  // for attachment functionality
  onFileChanged(event) {
    this.selectedFile = event.target.files[0]
    // console.log(event.target.files);
    const supportedExtensions = ['jpeg', 'jpg', 'png', 'zip', 'pdf', 'doc', 'dox', 'xls','xlsx'];
    var eventTarget = event.target
      const path = eventTarget.value.split('.');
      
      const extension = `${path[path.length - 1]}`;
      if (supportedExtensions.includes(extension)) {
        //upload
         /* For max and min file size start */
        if(this.selectedFile.size < 10000 || this.selectedFile.size > 15000000){
          var toaster = document.getElementById("snackbar");
          toaster.innerHTML = "File should be more than 10KB and less than 15MB in size";
          toaster.className = "show";
          setTimeout(function(){ toaster.className = toaster.className.replace("show", ""); }, 3000);
          return
          /* For max and min file size end */
        }else{
          this.uploading = true;
          if (event.target.files && event.target.files[0]) {
            var filesAmount = event.target.files.length;
            for (let i = 0; i < filesAmount; i++) {         
              /* For max 15 files Files acceptance */
              if ((this.fileArray.length) < 15){
                var uploadedFileName = event.target.files[i].name
                this.fileNameArray.push(uploadedFileName)

                var uploadedFile = event.target.files[i]
                this.fileArray.push(uploadedFile)
              }else{
                var toaster = document.getElementById("snackbar");
                toaster.innerHTML = "You can only upload a maximum of 15 files";
                toaster.className = "show";
                setTimeout(function(){ toaster.className = toaster.className.replace("show", ""); }, 3000);
              }
            }
          }
          setTimeout(() => {
            this.uploading = false;
            this.selectedFileName = this.selectedFile.name;
          }, 1000);
        }
      } else {
          //  show "invalid file type" message to user
          var toaster = document.getElementById("snackbar");
                toaster.innerHTML = "Invalid File type";
                toaster.className = "show";
                setTimeout(function(){ toaster.className = toaster.className.replace("show", ""); }, 3000);
          // reset value
          event.value = '';
      }
   
  }

  removeSelectedFile(index) {
    // Delete the item from fileNames list
    this.fileNameArray.splice(index, 1);
    // delete file from FileList
    this.fileArray.splice(index, 1);
   }

   // To set policy End date
   setPolicyEndDate() { 
    var regesterDate = new Date(this.policyStartDate);
    regesterDate.setFullYear(regesterDate.getFullYear() + 1);
    regesterDate.setDate(regesterDate.getDate()-1);
    this.policyEndDate = regesterDate;
  }

  saveOrSubmitProposalPage(processType){
    this.loading = true;
    
    
    this.data = {
      'proposersFullName':this.f.firstName+" "+this.f.lastName,
      'email':this.f.email,
      'professionalQualificationsDetails':this.f.qualification,
      'registrationYear':this.f.yearOfReg,
      'numberOfPatients':this.f.avgPatient,
      'sumInsured': localStorage.getItem("LOI"),
      'periodOfInsuranceStartDate':this.policyStartDate,
      'mobile': this.f.mobile,
      'medicineBranch':this.f.medicineBranch,
      'residentialAddress':this.f.address1,
      'medicalRegistrationNumber':this.f.medicalReg,
      'practiceYear': this.f.practiceYear,
      'specialization':this.f.selectedSpecialization,
      'periodOfInsuranceEndDate': this.policyEndDate,
      'memberOfMedicalAssociation':"",
      'memberOfMedicalAssociationName': this.f.AssoName,
      'memberOfMedicalAssociationAddress': this.f.assoAddress,
      'memberOfMedicalAssociationContactNo': this.f.AssoConact,
      'areYouAttached':'',
      'attachedDetails': '',
      'prevoiusHoldAnyPolicy':'',
      'retroactiveDate': '',
      // 'lastYearPolicyAttachment': '',
      // 'lastYearPolicyAttachmentSize': '',
      'anyClaims':'',
      'anyClaimsDetails': '',
      'authorizedSignatory':'',
      'proposalDeclaration':'',
      'declaration':'',
      'authorizedSignatoryDate':'',
      'authorizedSignatoryLocation':'',
      'secureNowTxnRefNo':localStorage.getItem("secureNowTxnRefNo"),
      'saveOrSubmit':processType
    }
    this.serviceURLService.saveDoctorProfessionalProposal(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      this.loading = false;
      if(processType == "save"){
        this.toasterService.showErrorToaster(successData.message);
      }else if(processType == "submit"){
        this.toasterService.showErrorToaster(successData.message);
        setTimeout(() => {
          this.router.navigate(['home']);
        }, 3000);
      }
      // console.log("successData united India",successData);
      
    }, errorData => {
      console.log("Oops..!! there is some error in save/ Submit proposal form");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
        this.toasterService.showErrorToaster(errorData.message);
      }
    })
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false});
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }

}
